import React from 'react';
import {connect} from 'react-redux';

import './styles.scss';
import Logo from 'assets/logo-dysmate.png';
import {isTablet} from 'react-device-detect';
import Gif from 'assets/rotation-from-horizontal-to-vertical.gif';
import {begin} from 'utils/beforeunload';

import Introduksjon from 'components/Introduksjon';
import Orddiktat from 'components/Orddiktat';
import Ordkjedetesten from 'components/Ordkjedetesten';
import Tulleordtesten from 'components/Tulleordtesten';
import SprakForstaelse from 'components/SprakForstaelse';
import Skrivehastighet from 'components/Skrivehastighet';
import Leseproven from 'components/Leseproven';
import Ordforstaelse from 'components/Ordforstaelse';
import Ferdig from 'components/Ferdig';
import ProgressBar from 'components/ProgressBar';

import getUserInfo from 'api/getUserInfo';
import getTestInfo from 'api/getTestInfo';
import setAnamneseVersion from 'api/setAnamneseVersion';
import {render} from 'react-dom';
import strings from 'utils/strings';
import {unlockAudioEngine} from 'utils/audioEngine';

var testSteps = [
	Introduksjon,
	Orddiktat,
	Ordkjedetesten,
	Tulleordtesten,
	Skrivehastighet,
	Leseproven,
	Ordforstaelse,
	Ferdig,
];

const testStepsNorming = [
	Introduksjon,
	Orddiktat,
	SprakForstaelse,
	Ordkjedetesten,
	Tulleordtesten,
	Skrivehastighet,
	Leseproven,
	Ordforstaelse,
	Ferdig,
];

const normingProgressLabelsByStep = new Map([
	[Orddiktat, () => strings.orddiktat],
	[SprakForstaelse, () => strings.sprakForstaelse],
	[Ordkjedetesten, () => strings.ordkjedetesten],
	[Tulleordtesten, () => strings.tulleordtesten],
	[Skrivehastighet, () => strings.skrivehastighet],
	[Leseproven, () => strings.leseproven],
	[Ordforstaelse, () => strings.ordforstaelse],
]);

const getNormingProgressSteps = (steps) => {
	return steps.filter((Step) => normingProgressLabelsByStep.has(Step));
};

const getNormingProgressLabel = (Step) => {
	const getLabel = normingProgressLabelsByStep.get(Step);

	return getLabel ? getLabel() : '';
};

const renderRemainingTests = [];
let includeDetailedAnamnese = false;
class ScreeningTest extends React.Component {
	constructor() {
		super();

		this.state = {
			isLoggedIn: false,
			isDldTest: false,
			includeAnamnese: false,
			testsToTake: [],
			isPortrait: true,
			isRotateDeviceFirstTimeRendered: true,
			needLanguageSetting: false,
			testUserInfo: null,
		};
	}

	componentDidMount() {
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
		getTestInfo().then((testInfo) => {
			const missingTests = [];
			const exclusiveTests = testInfo.exclusiveTests;
			const isNorming = testInfo.isNorming;
			const isDldTest = testInfo.isDldTest;
			const includeLongIntro = testInfo.anamnese === 1;
			const testUserInfo = testInfo.info || null;
			const testToContinue = Object.values(exclusiveTests);
			if (testToContinue.length) {
				for (let i = 0; i < testToContinue.length + 1; i++) {
					switch (testToContinue[i]) {
						case 1:
							renderRemainingTests.push(Orddiktat);
							break;
						case 2:
							renderRemainingTests.push(Ordkjedetesten);
							break;
						case 3:
							renderRemainingTests.push(Tulleordtesten);
							break;
						case 4:
							renderRemainingTests.push(Skrivehastighet);
							break;
						case 5:
							renderRemainingTests.push(Leseproven);
							break;
						case 6:
							renderRemainingTests.push(Ordforstaelse);
							break;
						case 7:
							if (isDldTest) {
								renderRemainingTests.push(SprakForstaelse);
							}
							break;
						default:
							break;
					}
					if (i === testToContinue.length) {
						renderRemainingTests.push(Ferdig);
					}
				}
				this.setState({
					testsToTake: missingTests,
					includeAnamnese: includeLongIntro,
					isDldTest,
					needLanguageSetting: true,
				});
			}

			getUserInfo().then((response) => {
				if (response.ok) {
					this.setState({
						isLoggedIn: true,
						includeAnamnese: includeLongIntro,
						isDldTest,
						testUserInfo,
					});
					begin();
				} else {
					window.location.href = `/`;
				}
			});
		});
	}

	componentWillUnmount() {
		window.addEventListener('resize', this.handleResize);
	}

	handleResize = () => {
		if (window.innerHeight > window.innerWidth) {
			this.setState({isPortrait: true});
		} else {
			this.setState({isPortrait: false});
		}
	};
	onSelectLanguage(lang) {
		unlockAudioEngine();

		strings.setLanguage(lang);
		this.setState({
			needLanguageSetting: false,
		});
	}
	render() {
		const {
			isLoggedIn,
			includeAnamnese,
			isPortrait,
			isRotateDeviceFirstTimeRendered,
		} = this.state;
		var CurrentStep;

		if (!isLoggedIn) {
			return null;
		}

		const {currentStepIndex} = this.props;
		let activeTestSteps = testSteps;

		if (renderRemainingTests.length) {
			activeTestSteps = renderRemainingTests;
		} else if (this.state.isDldTest) {
			activeTestSteps = testStepsNorming;
		}

		if (renderRemainingTests.length) {
			CurrentStep = renderRemainingTests[currentStepIndex];
		} else if (this.state.isDldTest) {
			CurrentStep = testStepsNorming[currentStepIndex];
		} else {
			CurrentStep = testSteps[currentStepIndex];
		}
		if (!isPortrait && isRotateDeviceFirstTimeRendered) {
			setTimeout(() => {
				this.setState({isRotateDeviceFirstTimeRendered: false});
			}, 3000);
		}

		const normingProgressSteps = this.state.isDldTest
			? getNormingProgressSteps(activeTestSteps)
			: [];
		const currentProgressStepIndex = normingProgressSteps.indexOf(
			CurrentStep
		);
		const shouldShowProgressBar =
			this.state.isDldTest &&
			!this.state.needLanguageSetting &&
			currentProgressStepIndex !== -1;

		return (
			<div>
				<header
					className={
						shouldShowProgressBar
							? 'lit-header lit-header--with-progress'
							: 'lit-header'
					}
				>
					<h1 className="lit-logo">
						<img
							className="lit-logo__img"
							src={Logo}
							alt="literate-logo"
						/>
					</h1>
					{shouldShowProgressBar && (
						<div className="lit-header__progress">
							<ProgressBar
								completedCount={currentProgressStepIndex + 1}
								totalCount={normingProgressSteps.length}
								currentLabel={getNormingProgressLabel(CurrentStep)}
							/>
						</div>
					)}
				</header>
				{Boolean(renderRemainingTests.length) &&
					this.state.needLanguageSetting && (
						<div className="lit-test-intro">
							<h1>{`Velg/vel språk`}</h1>

							<button
								className="lit-test-intro-language-button"
								tabIndex="1"
								onClick={() => this.onSelectLanguage('no')}
							>
								{`Norsk Bokmål`}
							</button>
							<button
								className="lit-test-intro-language-button"
								tabIndex="2"
								onClick={() => this.onSelectLanguage('nn')}
							>
								{`Norsk Nynorsk`}
							</button>
						</div>
					)}
				{isRotateDeviceFirstTimeRendered && !isPortrait && isTablet && (
					<div className="lit-test-rotation-gif">
						<img src={Gif} alt="rotate tablet gif" />
					</div>
				)}
				{!this.state.needLanguageSetting && (
					<div className="lit-wrapper--article text-center lit-screening-content">
						<CurrentStep
							includeLongAnamnese={includeAnamnese}
							isNorming={this.state.isNorming}
							isDldTest={this.state.isDldTest}
							testUserInfo={this.state.testUserInfo}
						/>
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {currentStepIndex} = state;

	return {
		currentStepIndex,
	};
};

export default connect(mapStateToProps)(ScreeningTest);
